import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import gsap from 'src/utils/gsapSetup.ts';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    gsap.to(window, {
      scrollTo: { y: 0, autoKill: true },
      duration: 0.1,
      ease: 'power2.out',
    });
  }, [pathname]);

  return null;
}
